import "./v2-question-surface.css";

export default function RecapTagPills({ values = [] }) {
  if (!values.length) return null;

  return (
    <div className="tgc-v2-recap-tags" aria-label={values.join(", ")}>
      {values.map((value) => (
        <span className="tgc-v2-recap-tag" key={value}>
          {value}
        </span>
      ))}
    </div>
  );
}
